import React from "react"
import {InterferometricStackType} from "../../../types/product";
import InterferometricStack from "./InterferometricStack";
import {getInterferometricStackIdentifierFrom} from "../../../helpers/interferometricStackHelper";

interface PropsType {
  stacks: InterferometricStackType[],
}

const InterferometricStacksList = (props: PropsType) => {
  const {
    stacks,
  } = props;

  return (
    <div className="container-search-results row m-0">
      {stacks.map((stack) => {
        const searchResultID = getInterferometricStackIdentifierFrom(stack);
        return (
          <InterferometricStack
            key={`interferometric-stacks-list-element-${searchResultID}`}
            searchResultID={searchResultID}
            stack={stack}
          />
        );
      })}
    </div>
  )

};

export default InterferometricStacksList;
